export default "__VITE_ASSET___9I3_of6__"